export default "__VITE_ASSET__cd08e698__"